<script>
import PlaceHolderImage from "../../assets/placeholder.png";
import { mapState } from "vuex";
import dataSheetNameList from "../../dataSheet.js";

const InitProduct = {
  title: "",
  subTitle: "",
  features: [],
  descriptions: [],
  applications: [],
  pictures: [],
};

export default {
  name: "Products",
  data() {
    return {
      selectedProduct: "",

      product: { ...InitProduct },
      PlaceHolderImage,
      isComingSoon: false,
      hasDataSheet: false,
    };
  },

  computed: {
    ...mapState({
      currentProduct: (state) => state.currentProduct,
    }),
  },

  watch: {
    currentProduct: {
      immediate: true,
      handler: function () {
        if (this.$route.query.pid) return;
        this.selectedProduct = this.currentProduct;
        this.handleSelectChange();
      },
    },
    "$route.params.locale"() {
      this.handleSelectChange();
    },
    "$route.query.pid": {
      immediate: true,
      handler(pid) {
        if (!pid) return;
        this.selectedProduct = [pid];
        this.handleSelectChange();
      },
    },
  },

  methods: {
    handleSelectChange() {
      const name = this.selectedProduct[this.selectedProduct.length - 1];
      if (!name) return;
      const product = this.i18n.productList[name];
      this.isComingSoon = product?.status === "coming-soon";
      this.hasDataSheet = dataSheetNameList.some((item) => item === name);
      if (!product) {
        this.$message.warning(`未找到${name}的产品信息`);
        this.product = { ...InitProduct };
        this.isComingSoon = false;
        this.hasDataSheet = false;
        return;
      }
      this.product = product;
    },
    handleDownload(product) {
      if (!this.hasDataSheet) return;
      window.open(`/files/${product.title}.pdf`);
    },
    handleContact() {
      this.$router.push(this.isCnLocale() ? "/home" : "/home/en");
      setTimeout(() => {
        const contact = document.querySelector("#contact");
        contact && contact.scrollIntoView(true);
      }, 500);
    },
  },
};
</script>

<template>
  <div class="products">
    <!-- <div class="products-select">
      <el-cascader
        v-model="selectedProduct"
        :options="i18n.productNameOptions"
        :placeholder="i18n.productSelectTip"
        @change="handleSelectChange"
      >
      </el-cascader>
    </div> -->
    <div v-if="product.title">
      <div class="title products-section">{{ product.title }}</div>
      <div class="sub-title products-section">
        <div class="sub-title__item">
          {{ product.subTitle }}
          <!-- <i
            class="el-icon-download sub-title__download"
            @click="handleDownload(product)"
          ></i> -->
          <span
            v-if="product.contact"
            class="sub-title__contact"
            @click="handleContact"
          >
            {{ i18n.contactLink }}
          </span>
          <span v-if="isComingSoon" class="sub-title__status">
            {{ i18n.comingSoon }}
          </span>
          <span
            v-else-if="hasDataSheet"
            class="sub-title__download"
            @click="handleDownload(product)"
          >
            {{ i18n.dataSheet }}
          </span>
        </div>
      </div>

      <template v-if="product.features">
        <div class="grid-2 products-section">
          <div class="pictures">
            <div class="item-title">{{ i18n.productPictureTip }}</div>
            <el-carousel :height="isMobile ? '280px' : '400px'">
              <el-carousel-item v-for="p in product.pictures" :key="p">
                <el-image
                  class="product-picture"
                  :src="'/' + p"
                  fit="contain"
                ></el-image>
              </el-carousel-item>
            </el-carousel>
          </div>

          <div class="features">
            <div class="item-title">{{ i18n.productFeatureTip }}</div>
            <p class="features_item" v-for="f in product.features" :key="f">
              <i
                class="el-icon-check"
                style="color: #33a1d0; font-weight: bold; margin-right: 12px"
              ></i>
              <span>{{ f }}</span>
            </p>
          </div>
        </div>

        <div class="grid-2 products-section">
          <div class="descriptions products-section">
            <div class="item-title">{{ i18n.productDescTip }}</div>
            <p
              class="descriptions_item"
              v-for="d in product.descriptions"
              :key="d"
            >
              {{ d }}
            </p>
          </div>

          <div class="applications products-section">
            <div class="item-title">{{ i18n.productionApplicationTip }}</div>
            <p
              class="application_item"
              v-for="a in product.applications"
              :key="a"
            >
              {{ a }}
            </p>
          </div>
        </div>
      </template>
    </div>
    <div v-if="!product.features" class="placeholder-image">
      <el-image
        :src="PlaceHolderImage"
        style="width: 100%; max-width: 400px"
      ></el-image>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "../../style/global.scss";
.products {
  min-height: 100vh;
  padding: 70px 0 120px;
  text-align: left;
  margin: 0 120px 0;
  font-size: 16px;

  &-select {
    margin-top: 24px;
    .el-cascader {
      width: 100%;
    }
  }

  &-section {
    margin-top: 8px;
  }

  .item-title {
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #4a4a4a;
    margin: 0;
    font-size: 24px;
    line-height: 1;

    position: relative;
    &::before {
      @extend .vertical-decoration;
    }
  }

  .title {
    font-size: 36px;
    font-weight: 700;
    position: relative;
    &::before {
      @extend .vertical-decoration;
    }
  }

  .sub-title {
    padding: 12px;
    border-radius: 8px;
    border: solid 1px #e5ebf2;
    position: relative;
    background-color: rgba(244, 247, 255, 0.85);
    margin-bottom: 16px;

    &__download {
      display: inline-block;
      margin-left: 16px;
      font-weight: bold;
      color: #33a1d0;
      cursor: pointer;
    }

    &__status {
      display: inline-block;
      margin-left: 16px;
      font-weight: bold;
      color: #33a1d0;
    }

    &__contact {
      display: inline-block;
      margin-left: 16px;
      font-weight: bold;
      color: #33a1d0;
      cursor: pointer;
    }

    &__item {
      font-size: 16px;
      font-weight: 700;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #4a4a4a;
      padding-left: 10px;
      padding-right: 5px;
    }
  }

  .pictures {
    .el-carousel {
      width: 600px;
    }

    .product-picture {
      width: 100%;
      height: 400px;
    }
  }

  .descriptions {
    width: 100%;
    border: solid 1px #e5ebf2;
    background-color: #f9fbff;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    overflow: hidden;
    padding: 20px 20px 10px;
    overflow: hidden;
    color: #4c4c4c;
    line-height: 2;
  }

  .features {
    width: 100%;
    border: solid 1px #e5ebf2;
    background-color: #f9fbff;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    overflow: hidden;
    padding: 20px 20px 10px;
    overflow: hidden;
  }

  .applications {
    width: 100%;
    border: solid 1px #e5ebf2;
    background-color: #f9fbff;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    overflow: hidden;
    padding: 20px 20px 10px;
    overflow: hidden;
  }

  .placeholder-image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20%;
    margin-bottom: 20%;
  }

  @media screen and (max-width: 600px) {
    margin: 0 20px;
    padding-top: 88px;

    .title {
      font-size: 30px;
    }

    .item-title {
      font-size: 21px;
      line-height: 1.25;
    }

    .pictures {
      .el-carousel {
        width: 100%;
      }

      .product-picture {
        height: 280px;
      }
    }

    .features,
    .descriptions,
    .applications {
      padding: 18px 16px 10px;
    }
  }
}
</style>
